exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.student-name-block[data-v-0d6ec2ef] {\n  margin: 0px 10px 10px 10px;\n  padding: 5px;\n  font-size: 16px;\n}\n#eraseButton[data-v-0d6ec2ef] {\n  color: #ff6666;\n}\nbutton[data-v-0d6ec2ef] {\n  font-size: 20px;\n  padding: 0;\n  margin-top: 10px;\n}\n#hasTest[data-v-0d6ec2ef] {\n  margin-top: 10px;\n}\n#message[data-v-0d6ec2ef] {\n  margin-top: 6px;\n  width: 90%;\n  height : 60px;\n  font-size:15px;\n  color:#505050;\n  border:solid 1px #ccc;\n  border-radius: 3px;\n  margin-top: 12px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-0d6ec2ef","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/timetable/TemporaryLecturePanel.vue
// module id = 474
// module chunks = 0